import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx } from "vue"

import {computed, onMounted, provide, watch} from 'vue';
import OperatorApplicationSideMenu from "~/operatorApplication/vue/layout/OperatorApplicationSideMenu.vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {__} from "~/ts/library/Translate";

import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import OperatorApplicationExportPayloadDialogInterface
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/OperatorApplicationExportDialogInterface";
import ForwardToOperatorEventInterface
    from "~/operatorApplication/vue/dialogs/dialog/topmenu/ForwardToOperatorEventInterface";


import SideMenuTabs from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuTabs.vue";
import SideMenuInfoTab
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/SideMenuInfoTab.vue";
import {
    DataProviderManageEntityTabInjection,
    DataProviderManageEntityTabPayloadInterface
} from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dataProvider/editTab/Inteface";
import {SideMenuTabInteface} from "~/operatorApplication/vue/dialogs/dialog/sidemenu/Interface";
import DataProviderEditEntityTab
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dataProvider/editTab/DataProviderEditEntityTab.vue";
import Random from "~/ts/library/Random";
import OperatorApplicationWebRtcCall, {
    EVENT_OPEN_CALL_TAB
} from "~/operatorApplication/ts/service/webRtc/OperatorApplicationWebRtcCall";
import {
    EVENT_OPEN_CROSS_OPERATOR_CONVERSATION_TAB,
    EVENT_OPEN_MESSAGE_SEARCH_TAB,
    OperatorApplicationEventManager
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import OperatorApplicationWebRtcCallDisplay
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/call/OperatorApplicationWebRtcCallDisplay.vue";
import DialogsTab from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dialogsTab/DialogsTab.vue";
import SideMenuCrossOperatorsGroupChatInfoTab
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/crossOperatorGroupChatInfo/SideMenuCrossOperatorsGroupChatInfoTab.vue";
import MessageSearchTab from "~/operatorApplication/vue/dialogs/dialog/sidemenu/messageSearch/MessageSearchTab.vue";
import OperatorApplicationCrossOperatorConversation
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/crossOperatorConversation/OperatorApplicationCrossOperatorConversation.vue";
import CoreUiChatHistoryHelper from "~/core-ui/vue/chat/CoreUiChatHistoryHelper";


import {ref} from "vue";

const __default__ = {
    name: "DialogSideMenu"
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    userdata: {},
    buddyList: {},
    selectedMessagesAsText: {},
    onMessageTagClick: { type: Function }
  }, {
    "showMessageSearch": { type: Boolean },
    "showMessageSearchModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["forward", "toggle-ban", "toggle-cobrowse", "toggle-mute", "export-dialog", "emit-custom-event"], ["update:showMessageSearch"]),
  setup(__props: any, { emit: __emit }) {

let props = __props;

let showMessageSearch = _useModel<boolean>(__props, "showMessageSearch");

let emits = __emit;

const INFO_TAB = "info";
const DIALOGS_TAB = "dialogs";
//const COPILOT_TAB = "copilot";
const CROSS_OPERATOR_CONVERSATION_TAB = "crossOperatorConversation";
const DATA_PROVIDER_ENTITY_MANAGE_TAB = "dataProviderEntityManage";
const WEB_RTC_TAB = "webRtc";
const CROSS_OPERATOR_GROUP_INFO_TAB = "crossOperatorGroupInfoTab";
const MESSAGE_SEARCH_TAB = "messageSearch";

let site = computed(() => {
    return OperatorAccountStore.sitesDictionary.value[props.userdata.siteId];
});

let dataProviderEntityManageTab = ref<{
    username: string,
    key: string,
    payload: DataProviderManageEntityTabPayloadInterface
}>();


let displayedTab = ref(INFO_TAB);

let isWebRtcDisplayed = computed(() => displayedTab.value == WEB_RTC_TAB);

let isDialogDisplayed = computed(() => displayedTab.value == DIALOGS_TAB);


function openWebRtcTabIfAvailable() {
    if (tabsMenu.value.find(tab => tab.id == WEB_RTC_TAB)) {
        displayedTab.value = WEB_RTC_TAB;
    }
}


onMounted(() => {
    openWebRtcTabIfAvailable();
});

addDisposableEvent(
    OperatorApplicationEventManager.addEventListener(
        EVENT_OPEN_CALL_TAB,
        username => {
            if (username == props.userdata.username) {
                openWebRtcTabIfAvailable();
            }
        }
    )
);

addDisposableEvent(
    OperatorApplicationEventManager.addEventListener(
        EVENT_OPEN_MESSAGE_SEARCH_TAB,
        username => {
            if (username == props.userdata.username) {
                if (showMessageSearch.value) {
                    displayedTab.value = MESSAGE_SEARCH_TAB;
                }
            }
        }
    )
);


addDisposableEvent(
    OperatorApplicationEventManager.addEventListener(
        EVENT_OPEN_CROSS_OPERATOR_CONVERSATION_TAB,
        username => {
            if (username == props.userdata.username) {
                if (showCrossOperatorConversationTab.value) {
                    displayedTab.value = CROSS_OPERATOR_CONVERSATION_TAB;
                }
            }
        }
    )
);





provide(DataProviderManageEntityTabInjection, p => {
    dataProviderEntityManageTab.value = {
        username: props.userdata.username,
        payload: p,
        key: Random.uid(32)
    };
    displayedTab.value = DATA_PROVIDER_ENTITY_MANAGE_TAB;
});


let sideMenuWidth = computed({
    get: () => {
        if (isWebRtcDisplayed.value) {
            return OperatorApplicationConfigInstance.dialogWebRtcSideMenuWidth;
        }
        return OperatorApplicationConfigInstance.dialogSideMenuWidth;
    },
    set: (value: number) => {
        if (isWebRtcDisplayed.value) {
            OperatorApplicationConfigInstance.dialogWebRtcSideMenuWidth = value;
        } else {
            OperatorApplicationConfigInstance.dialogSideMenuWidth = value;
        }
    }
});

/*
let isCopilotAvailable = computed(() => {
    let result = false;
    if (site.value) {
        result = getChatCopilotsBySite(site.value).length > 0;
    }
    return result;
});
*/

let showCrossOperatorConversationTab = computed(() => {
    return !CoreUiChatHistoryHelper.isOneOfCrossOperatorsChat(props.userdata) && !!props.userdata.crossOperatorConversationUsername;
})

let crossOperatorGroup = computed(() => {
    return OperatorAccountStore.crossOperatorChat.value[props.userdata.username]?.group;
})

let tabsMenu = computed(() => {
    let result: SideMenuTabInteface[] = [];

    if (currentCall.value) {
        result.push({
            id: WEB_RTC_TAB,
            descr: "Звонок"
        });
    }
    if (!CoreUiChatHistoryHelper.isOneOfCrossOperatorsChat(props.userdata)) {
        result.push({
            id: INFO_TAB,
            descr: __("Информация")
        });
        if (showCrossOperatorConversationTab.value) {
            result.push({
                id: CROSS_OPERATOR_CONVERSATION_TAB,
                descr: "Обсуждение",
                badge: props.userdata.crossOperatorConversationUnreadMessageCount > 0 ? props.userdata.crossOperatorConversationUnreadMessageCount : undefined
            });
        }
        if (props.userdata.lastDialog) {
            result.push({
                id: DIALOGS_TAB,
                descr: __("Диалоги")
            });
        }


        /*
        if (isCopilotAvailable.value) {
            result.push({
                id: COPILOT_TAB,
                descr: "Copilot",
                unmountOnClose: true
            });
        }
        */
        let dataProviderPayload = dataProviderEntityManageTab.value;
        if (dataProviderPayload && dataProviderPayload.username == props.userdata.username) {
            result.push({
                id: DATA_PROVIDER_ENTITY_MANAGE_TAB,
                descr: `${dataProviderPayload.payload.platform.descr}: ${dataProviderPayload.payload.entityType.descr}`,
                closable: true
            });
        }
    } else {
        if (crossOperatorGroup.value) {
            result.push({
                id: CROSS_OPERATOR_GROUP_INFO_TAB,
                descr: __("Информация")
            })
        }
    }
    if (showMessageSearch.value) {
        result.push({
            id: MESSAGE_SEARCH_TAB,
            descr: __("Поиск"),
            closable: true
        });
    }
    return result;
});

function onTabRemove(name: string) {
    if (name == DATA_PROVIDER_ENTITY_MANAGE_TAB) {
        closeDataProviderEntityManageTab()
    }
    if (name == MESSAGE_SEARCH_TAB) {
        showMessageSearch.value = false;
    }
}

function closeDataProviderEntityManageTab() {
    dataProviderEntityManageTab.value = null;
}

let username = computed(() => props.userdata.username);

watch(username, () => {
    closeDataProviderEntityManageTab();
    openWebRtcTabIfAvailable();
    showMessageSearch.value = false;
});

watch(showMessageSearch, value => {
    if (value) {
        displayedTab.value = MESSAGE_SEARCH_TAB;
    }
})

let currentCall = computed(() => {
    let call = OperatorApplicationWebRtcCall.getCurrentCall() as OperatorApplicationWebRtcCall;
    if (call?.getCallData()?.username === props.userdata.username) {
        return call;
    }
    return null;
});



return (_ctx: any,_cache: any) => {
  return (_unref(tabsMenu).length)
    ? (_openBlock(), _createBlock(OperatorApplicationSideMenu, {
        key: 0,
        class: "dialog-right-side-menu",
        right: "",
        width: _unref(sideMenuWidth),
        "onUpdate:width": _cache[8] || (_cache[8] = ($event: any) => (_isRef(sideMenuWidth) ? (sideMenuWidth).value = $event : sideMenuWidth = $event)),
        "min-width": 250,
        "max-width": (_unref(isWebRtcDisplayed) || _unref(isDialogDisplayed)) ? 1200 : 500,
        style: {
            overflow: 'hidden !important'
        }
      }, {
        default: _withCtx(() => [
          _createVNode(SideMenuTabs, {
            modelValue: _unref(displayedTab),
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(displayedTab) ? (displayedTab).value = $event : displayedTab = $event)),
            tabs: _unref(tabsMenu),
            onRemove: onTabRemove
          }, {
            [CROSS_OPERATOR_GROUP_INFO_TAB]: _withCtx(() => [
              (_unref(crossOperatorGroup))
                ? (_openBlock(), _createBlock(SideMenuCrossOperatorsGroupChatInfoTab, {
                    key: 0,
                    group: _unref(crossOperatorGroup)
                  }, null, 8, ["group"]))
                : _createCommentVNode("", true)
            ]),
            [MESSAGE_SEARCH_TAB]: _withCtx(() => [
              (_openBlock(), _createBlock(MessageSearchTab, {
                key: __props.userdata.username,
                site: _unref(site),
                userdata: __props.userdata
              }, null, 8, ["site", "userdata"]))
            ]),
            [INFO_TAB]: _withCtx(() => [
              _createVNode(SideMenuInfoTab, {
                userdata: __props.userdata,
                "buddy-list": __props.buddyList,
                "selected-messages-as-text": __props.selectedMessagesAsText,
                "on-message-tag-click": __props.onMessageTagClick,
                onForward: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('forward', $event))),
                onToggleBan: _cache[1] || (_cache[1] = ($event: any) => (_unref(emits)('toggle-ban', $event))),
                onToggleCobrowse: _cache[2] || (_cache[2] = ($event: any) => (_unref(emits)('toggle-cobrowse'))),
                onToggleMute: _cache[3] || (_cache[3] = ($event: any) => (_unref(emits)('toggle-mute'))),
                onExportDialog: _cache[4] || (_cache[4] = ($event: any) => (_unref(emits)('export-dialog', $event))),
                onEmitCustomEvent: _cache[5] || (_cache[5] = ($event: any) => (_unref(emits)('emit-custom-event', $event)))
              }, null, 8, ["userdata", "buddy-list", "selected-messages-as-text", "on-message-tag-click"])
            ]),
            [DATA_PROVIDER_ENTITY_MANAGE_TAB]: _withCtx(() => [
              (_unref(dataProviderEntityManageTab))
                ? (_openBlock(), _createBlock(DataProviderEditEntityTab, {
                    key: _unref(dataProviderEntityManageTab).key,
                    "entity-type-id": _unref(dataProviderEntityManageTab).payload.entityType.id,
                    "auth-primary-id": _unref(dataProviderEntityManageTab).payload.integration.authPrimaryId,
                    "platform-id": _unref(dataProviderEntityManageTab).payload.platform.id,
                    "entity-id": _unref(dataProviderEntityManageTab).payload.entityId,
                    username: __props.userdata.username,
                    "site-id": __props.userdata.siteId,
                    onClose: _cache[6] || (_cache[6] = ($event: any) => (closeDataProviderEntityManageTab()))
                  }, null, 8, ["entity-type-id", "auth-primary-id", "platform-id", "entity-id", "username", "site-id"]))
                : _createCommentVNode("", true)
            ]),
            [WEB_RTC_TAB]: _withCtx(() => [
              (_unref(currentCall))
                ? (_openBlock(), _createBlock(OperatorApplicationWebRtcCallDisplay, {
                    key: 0,
                    call: _unref(currentCall),
                    class: "p-2"
                  }, null, 8, ["call"]))
                : _createCommentVNode("", true)
            ]),
            [DIALOGS_TAB]: _withCtx(() => [
              (_openBlock(), _createBlock(DialogsTab, {
                key: __props.userdata.username,
                userdata: __props.userdata
              }, null, 8, ["userdata"]))
            ]),
            [CROSS_OPERATOR_CONVERSATION_TAB]: _withCtx(() => [
              _createVNode(OperatorApplicationCrossOperatorConversation, {
                class: "side-menu-inner-padding",
                client: _unref(props).userdata,
                "buddy-list": _unref(props).buddyList,
                site: _unref(site)
              }, null, 8, ["client", "buddy-list", "site"])
            ]),
            _: 2
          }, 1032, ["modelValue", "tabs"])
        ]),
        _: 1
      }, 8, ["width", "max-width"]))
    : _createCommentVNode("", true)
}
}

})